export const fragmentShaderOptimized = `
uniform float uOpacity;
uniform float uTime;
uniform float uBrightnessFlickerScale;
uniform float uBrightnessFlickerAmount;
uniform float uGrayscale;
uniform float uContrast;
uniform float uBrightness;
uniform float uDitherEnabled;
uniform float uDitherScale;
uniform sampler2D uNoiseTexture;

varying vec3 vColor;
varying vec2 vUv;

// Bayer 4x4 dither matrix
float bayer4x4(vec2 pos) {
  int x = int(mod(pos.x, 4.0));
  int y = int(mod(pos.y, 4.0));
  int index = x + y * 4;
  
  // Bayer matrix values (0-15 normalized to 0-1)
  float matrix[16];
  matrix[0] = 0.0/16.0;   matrix[1] = 8.0/16.0;   matrix[2] = 2.0/16.0;   matrix[3] = 10.0/16.0;
  matrix[4] = 12.0/16.0;  matrix[5] = 4.0/16.0;   matrix[6] = 14.0/16.0;  matrix[7] = 6.0/16.0;
  matrix[8] = 3.0/16.0;   matrix[9] = 11.0/16.0;  matrix[10] = 1.0/16.0;  matrix[11] = 9.0/16.0;
  matrix[12] = 15.0/16.0; matrix[13] = 7.0/16.0;  matrix[14] = 13.0/16.0; matrix[15] = 5.0/16.0;
  
  for (int i = 0; i < 16; i++) {
    if (i == index) return matrix[i];
  }
  return 0.0;
}
  
void main() {
  vec3 color = vColor;
  
  // Brightness fluctuation noise using texture lookup
  // Map 0..1 to -1..1 for similar behavior to snoise
  float brightnessNoise = texture2D(uNoiseTexture, vUv * uBrightnessFlickerScale + vec2(uTime)).r;
  brightnessNoise = (brightnessNoise * 2.0) - 1.0;

  float noiseMult = 1.0 + brightnessNoise * uBrightnessFlickerAmount;
  
  // Apply brightness with fluctuation
  color *= uBrightness * noiseMult;
  
  // Apply contrast
  color = (color - 0.5) * uContrast + 0.5;
  
  // Grayscale conversion
  float gray = dot(color, vec3(0.299, 0.587, 0.114));
  color = mix(color, vec3(gray), uGrayscale);
  
  // Dithering
  if (uDitherEnabled > 0.5) {
    vec2 pixelPos = gl_FragCoord.xy / uDitherScale;
    float threshold = bayer4x4(pixelPos);
    
  // Get luminance for threshold comparison
    float luminance = dot(color, vec3(0.299, 0.587, 0.114));
    
    // Discard pixels below threshold (creates stipple/halftone effect)
    if (luminance < threshold) {
      discard;
    }

    color = vec3(1.0);
  }
  
  // Clamp colors
  color = clamp(color, 0.0, 1.0);
  
  gl_FragColor = vec4(color, uOpacity);
}
`;
